export default __webpack_public_path__ + "static/media/bin.d89b3576.svg";